__turbopack_context__.v({
  "message": "OrderNotesCard-module-scss-module__ReEHNG__message",
  "pin-button": "OrderNotesCard-module-scss-module__ReEHNG__pin-button",
  "pin-button-pinned": "OrderNotesCard-module-scss-module__ReEHNG__pin-button-pinned",
});
